import React, { useEffect, useState, useRef } from "react";
import MultiEntityCard from "../../../components/MultiEntities/MultiEntityCard";
import MultiEntityButton from "../../../components/MultiEntities/MultiEntityButton";
import { useSelector, useDispatch } from "react-redux";
import {
  multiEntityAllMappings,
  resetMultiEntityAllMappingsData,
} from "../../../redux/features/multientity/multientity";
import Loader from "../../../components/Loader/Index";

import ResponsiveAppBarLogout from "../../../components/ResponsiveAppBar/ResponsiveAppBarLogout/index";

const MultiEntities = () => {
  const {
    multiEntityAllMappingsData,
    multiEntityAllMappingsLoading,
    conciergeLoading,
  } = useSelector((state) => state.multientity);
  const entityData = JSON.parse(sessionStorage.getItem("response"));
  const dispatch = useDispatch();

  const [openAllEntities, setOpenAllEntities] = useState(false);
  const [slideCard, setSlideCard] = useState(false);
  const [animatedLoader, setAnimatedLoader] = useState(false);
  const [cardId, setCardId] = useState("");
  const [selectId, setSelectId] = useState("");
  const [favEntityData, setFavEntityData] = useState([]);
  const [page, setPage] = useState(1);
  const isFirstRun = useRef(true);

  const handleEntitySelect = (entity) => {
    setSelectId(entity?.id);
    sessionStorage.setItem("subEntitySelected", "true");
  };

  let queryParams = {
    favourite: "Y",
    page_no: page,
    page_size: 100,
    userId: entityData?.employees?.user_id,
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (!multiEntityAllMappingsLoading && multiEntityAllMappingsData) {
      let store = multiEntityAllMappingsData?.mappings?.filter((val) => {
        return val?.favourite === "Y";
      });
      setFavEntityData((prev) => [...prev, ...store]);
      if (page < multiEntityAllMappingsData?.title?.total_pages) {
        setPage((prev) => prev + 1);
      }
    }
  }, [multiEntityAllMappingsData]);

  useEffect(() => {
    sessionStorage.setItem("primary_entity_data", JSON.stringify(entityData));
  }, []);
  useEffect(() => {
    dispatch(resetMultiEntityAllMappingsData());
    dispatch(multiEntityAllMappings(queryParams));
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem("favourite_entities", JSON.stringify(favEntityData));
  }, [favEntityData]);

  return (
    <>
      <ResponsiveAppBarLogout slideCard={slideCard} />
      <div
        className="bg-primary-bg w-full  pb-padding-md"
        style={{
          display: animatedLoader && "flex",
          justifyContent: animatedLoader && "center",
          alignItems: animatedLoader && "center",
          height: "var(--full-height)",
        }}
      >
        {animatedLoader ? (
          <Loader />
        ) : (
          <div className="h-full flex flex-col">
            <div
              className={`multiEntity_intro_div  mb-margin-xl mx-auto ${
                slideCard && "responsivAppBarUpAnimate"
              }`}
            >
              <h1 className="text-center text-text-primary font-semibold tracking-wider text-font-xl capitalize ">
                Hi, {entityData?.employees?.first_name}!
              </h1>
              <p className="text-center text-text-primary text-font-md font-normal mt-margin-md ">
                Multiple entities found, highlighted below is the entity you're
                currently using, along with your favourite ones. Either continue
                to home dashboard or select a different entity to proceed with,
                you can swap the entities later through the Quick Swap tab.
              </p>
            </div>

            <div className="overflow-auto">
              <div
                className={`flex  gap-gap-md flex-wrap  w-std-width mx-auto multiEntityCardsC ${
                  multiEntityAllMappingsLoading === true ? "h-full" : "h-auto"
                }`}
                style={{
                  justifyContent:
                    multiEntityAllMappingsLoading === true
                      ? "center"
                      : "flex-start",
                  alignItems:
                    multiEntityAllMappingsLoading === true
                      ? "center"
                      : "flex-start",
                }}
              >
                {multiEntityAllMappingsLoading === false ? (
                  <>
                    <MultiEntityCard
                      currentEntityName={entityData?.entity?.entity_name}
                      currentEntityPan={entityData?.entity?.entity_pan}
                      isActive={true}
                      type={"multiEntityCard"}
                      conciergeLoading={conciergeLoading}
                      setSlideCard={setSlideCard}
                      setOpenAllEntities={setOpenAllEntities}
                      setAnimatedLoader={setAnimatedLoader}
                      slideCard={slideCard}
                      cardId={cardId}
                      setCardId={setCardId}
                    />
                    {favEntityData.map((val) => {
                      return (
                        <MultiEntityCard
                          currentEntityName={entityData?.entity?.entity_name}
                          currentEntityPan={entityData?.entity?.entity_pan}
                          setSelectId={handleEntitySelect}
                          type={"multiEntityCard"}
                          card={val}
                          conciergeLoading={conciergeLoading}
                          setSlideCard={setSlideCard}
                          setOpenAllEntities={setOpenAllEntities}
                          setAnimatedLoader={setAnimatedLoader}
                          slideCard={slideCard}
                          cardId={cardId}
                          setCardId={setCardId}
                        />
                      );
                    })}
                  </>
                ) : (
                  <Loader />
                )}
              </div>
            </div>

            <div
              className={`${
                openAllEntities
                  ? "me_button_entity_container_transition me_button_entity_container"
                  : "me_button_entity_container"
              }`}
            >
              <MultiEntityButton
                setOpenAllEntities={setOpenAllEntities}
                openAllEntities={openAllEntities}
                data={favEntityData}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MultiEntities;
